// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aeCJ","content":"styles_content__3TDg1"};